import { AuthProvider } from '@partment/auth'
import { APP_NAME } from '@partment/types'
import { FC, Suspense } from 'react'
import { ClientSessionProvider } from './ClientSessionProvider'
import { CurrencyProvider } from './CurrencyContext'
import { QueryClientProvider } from './QueryClientProvider'
import { RootThemeProvider } from './RootThemeProvider'
import SharedAnalytics from '../scripts'

const AUTH_BASE_PATH_BY_APP_NAME: Partial<Record<APP_NAME, string>> = {
  [APP_NAME['PARENT-BRAND']]: '/sso/api/auth',
  // co-owner moved from the root to basePath '/co-owner'; its NextAuth client
  // endpoints must match (like every other subpath app below).
  [APP_NAME['CO-OWNER']]: '/co-owner/api/auth',
  [APP_NAME.ACCOUNTS_PORTAL]: '/accounts-portal/api/auth',
  [APP_NAME.GLOBAL_PORTAL]: '/global-portal/api/auth',
  [APP_NAME.RENTAL_MARKETPLACE]: '/stays/api/auth',
  [APP_NAME.LANDLORD]: '/stays/landlord/api/auth',
}

export const SharedRootProvider: FC<{
  children: React.ReactNode
  appName: APP_NAME
}> = ({ children, appName }) => {
  const authBasePath = AUTH_BASE_PATH_BY_APP_NAME[appName]

  return (
    <>
      <ClientSessionProvider authBasePath={authBasePath}>
        <QueryClientProvider>
          <CurrencyProvider>
            <AuthProvider>
              <RootThemeProvider appName={appName}>
                {children}
              </RootThemeProvider>
            </AuthProvider>
          </CurrencyProvider>
        </QueryClientProvider>
      </ClientSessionProvider>

      <Suspense>
        <SharedAnalytics />
      </Suspense>
    </>
  )
}
